export default "__VITE_PUBLIC_ASSET__0519b11b__"